import React, { createContext, useContext, useState, useEffect } from 'react';
import { siteApi } from '../config/api';

const SiteSettingsContext = createContext(null);

const DEFAULTS = {
  shop_name: 'ZOZO Burger',
  contact_email: 'info@zozo-burger.de',
  contact_phone: '04101 39 84 850',
  company_owner: 'Kereschma Fayazi',
  company_street: 'Möwenstraße 2',
  company_postal_code: '25462',
  company_city: 'Rellingen',
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    siteApi.getPublicSettings()
      .then(res => {
        if (res.data?.success && res.data?.data) {
          setSettings(prev => ({ ...prev, ...res.data.data }));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const ctx = useContext(SiteSettingsContext);
  if (!ctx) return DEFAULTS;
  return ctx;
}
